module.exports = __webpack_public_path__ + "img/adminD 2.dbcd4f15.png";